import { type PropsWithChildren } from 'react';

export const Label = (_props: PropsWithChildren) => null;
